module.exports = __webpack_public_path__ + "static/media/shutterstock_111365225.4fbb8b23.jpg";